import { render, staticRenderFns } from "./_purchasesReturns.vue?vue&type=template&id=6bf8de33&scoped=true&"
import script from "./_purchasesReturns.vue?vue&type=script&lang=js&"
export * from "./_purchasesReturns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf8de33",
  null
  
)

export default component.exports